// extracted by mini-css-extract-plugin
module.exports = {"widgetTypeForm":"WidgetTypeForm_widgetTypeForm__2yE_M","checkboxList":"WidgetTypeForm_checkboxList__RN1Vl","sources":"WidgetTypeForm_sources__2RIFp"};